import { renderSlot as _renderSlot, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  class: "swiper-container w-full",
  ref: "swiperContainer"
}
const _hoisted_2 = { class: "swiper-wrapper items-end" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_swiper_navigation_component = _resolveComponent("swiper-navigation-component")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _renderSlot(_ctx.$slots, "default")
      ])
    ], 512),
    (_ctx.showNavigation)
      ? (_openBlock(), _createBlock(_component_swiper_navigation_component, { key: 0 }))
      : _createCommentVNode("", true)
  ]))
}